import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import './AutosuggestInput.scss';
import { analyticsTrack } from '../../../analyticsUtils';

const TRACKING_EVENT_TIME = 1000;

const renderSuggestion = (suggestion) => (
  <span>{suggestion}</span>
);

const getSuggestionValue = (suggestion) => (
  suggestion
);

class AutosuggestInput extends Component {
  static trackEvent() {
    analyticsTrack('User typed a role', { location: 'Search Index' });
  }

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      suggestions: [],
    };
    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.getSuggestions = this.getSuggestions.bind(this);
    this.trackEvent = debounce(this.constructor.trackEvent.bind(this), TRACKING_EVENT_TIME);
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onChange(event, { newValue }) {
    const { handleChange } = this.props;
    handleChange(newValue);
    this.setState({
      value: newValue,
    });
    this.trackEvent();
  }

  getSuggestions(value) {
    const { allSuggestions } = this.props;
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : allSuggestions.filter((sug) => sug.toLowerCase().indexOf(inputValue) !== -1);
  }

  render() {
    const { value, suggestions } = this.state;
    const { classNames, location } = this.props;

    const inputProps = {
      placeholder: 'Type a role...',
      value,
      id: location ? `${location}-role` : 'role',
      onChange: this.onChange,
      className: classNames,
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

AutosuggestInput.propTypes = {
  allSuggestions: PropTypes.arrayOf(PropTypes.string),
  handleChange: PropTypes.func.isRequired,
  classNames: PropTypes.string,
  value: PropTypes.string,
  location: PropTypes.string,
};

AutosuggestInput.defaultProps = {
  allSuggestions: [],
  classNames: '',
  value: '',
  location: '',
};

export default AutosuggestInput;
